(function () {
  function init() {
    var roots = document.querySelectorAll('.vg-cfo');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var items = root.querySelectorAll('[data-reveal]');
      if (!items.length) return;

      if (!('IntersectionObserver' in window)) {
        items.forEach(function (el) { el.classList.add('is-in'); });
        return;
      }

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.16, rootMargin: '0px 0px -40px 0px' });

      items.forEach(function (el) { io.observe(el); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
